import { render, staticRenderFns } from "./ReworksListPerStudent.vue?vue&type=template&id=027df5d2"
import script from "./ReworksListPerStudent.vue?vue&type=script&lang=js"
export * from "./ReworksListPerStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports